import * as Sentry from '@sentry/react';

import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import user from 'js/lib/user';

// Pendo variables can optionally be passed in order to create custom segmentation
type VisitorSegmentationPendoVariable = {};

type Props = { visitorSegmentationPendoVariable?: VisitorSegmentationPendoVariable };

const initLearnerPlatformFeedbackPendo = (props?: Props) => {
  try {
    const { external_id: externalId, is_staff: isStaff, is_superuser: isSuperuser } = user.get();

    pendo.init(
      {
        visitor: {
          id: externalId,
          isStaff,
          isSuperuser,
          ...(props?.visitorSegmentationPendoVariable || {}),
        },
      },
      LEARNER_API_KEY
    );
  } catch (error) {
    Sentry.captureException(error);
  }
};

export default initLearnerPlatformFeedbackPendo;
